export default __webpack_public_path__ + "static/media/Aged Bone Flute.02b2f197.jpg";